import React, { useState, useEffect } from 'react';
import { Modal, message } from 'antd';
import PaymentConfirmationModal from '../payment-confirmation-modal/payment-confirmation-modal';
import OfflinePaymentModal from '../offlinepayment-modal/offline-payment-modal';
import { PlansBox } from '../plans-box/plans-box';
import paymentTypes from '../payment-types';
import { createKahsierFrame, removeKashierFrame } from '../../../utils/payments.kashier';
import packagesService from '../../../services/packages.service';
import { notifyError } from '../../../utils/notification';

export function PackagesBox({ contentComponent, onSelect, mode = 'horizontal' }: any): any {
	const [offPayModalVisible, setOffPayModalVisiblity] = useState<boolean>(false);
	const [confPayModalVisible, setConfPayModalVisiblity] = useState<boolean>(false);
	const [currentPaymentInfo, setCurrentPaymentInfo] = useState<any>();
	const [plans, setPlans] = useState<any>([]);
	const [iframeLoading, setIframeLoading] = useState<boolean>(false);

	const fetchPackages = async () => {
		try {
			var interviewsPackages = await packagesService.getInterviewsPackages({ isCustom: false, isActive: true });
		} catch (e: any) {
			console.error(e);
			message.error(e.message);
			return;
		}
		setPlans(interviewsPackages);
	};

	useEffect(() => {
		fetchPackages();
	}, []);

	const onSubmit = async e => {
		//Call api to get order info
		let resp: any = await packagesService.purchasePackage(currentPaymentInfo.id);
		let order = resp.data;
		if (!currentPaymentInfo) return notifyError('Please select a package first');
		createKahsierFrame({
			amount: order.amount,
			orderHash: order.hash,
			orderId: order._id,
			merchantId: order.mid,
			currency: order.currency,
			companyName: order.companyName
		}).then(() => {
			let kashierBtn = document.getElementById('el-kashier-button');
			kashierBtn && kashierBtn.click();
			setIframeLoading(true);
		});
	};
	return (
		<>
			<PlansBox
				mode={mode}
				plans={plans}
				onSelect={p => {
					if (onSelect !== undefined && !onSelect(p)) {
						return;
					}
					setCurrentPaymentInfo({
						id: p.id,
						type: paymentTypes.INTERVIEWS_PACKAGE,
						title: p.title,
						total: p.price.usd
					});
					setConfPayModalVisiblity(true);
				}}
				contentComponent={contentComponent}
			/>

			{currentPaymentInfo && (
				<PaymentConfirmationModal
					paymentInfo={currentPaymentInfo}
					visible={confPayModalVisible}
					onSubmit={onSubmit}
					onCancel={() => {
						setConfPayModalVisiblity(false);
						setIframeLoading(false);
						removeKashierFrame();
					}}
					onOffline={() => setOffPayModalVisiblity(true)}
					loading={iframeLoading}
				/>
			)}
			<OfflinePaymentModal visible={offPayModalVisible} onCancel={() => setOffPayModalVisiblity(false)} />
		</>
	);
}
